export default __webpack_public_path__ + "static/media/aarini.21f73e0d.jpeg";